import { Component, EventEmitter, Inject, Output } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatSelectModule } from '@angular/material/select'
import { NgClass } from '@angular/common'
import { SugestaoAgrupamentoService } from '../../../core/services/sugestao-agrupamento/sugestao-agrupamento.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'

type FlowState = 'idle' | 'generated'

interface PassageiroUI {
  id: string
  nome: string
  hora: string
  speaker: boolean
  movingTo: number | null
}

interface GrupoUI {
  itemPropostaId: number
  tipoVeiculoDescricao: string
  capacidade: number
  tipoTrechoId: number
  data: string
  horaInicio: string
  horaFinal: string
  totalPassageiros: number
  passageiros: PassageiroUI[]
  movingPassageiroId: string | null
}

@Component({
  selector: 'modal-sugestao-agrupamento',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatSelectModule,
    NgClass,
  ],
  templateUrl: './modal-sugestao-agrupamento.component.html',
  styleUrl: './modal-sugestao-agrupamento.component.scss',
})
export class ModalSugestaoAgrupamentoComponent {
  @Output() response = new EventEmitter<boolean>()

  state: FlowState = 'idle'
  janelaMinutos = 60
  modoAgrupamento = 0
  loading = false

  grupos: GrupoUI[] = []
  semCorrespondencia: any[] = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalSugestaoAgrupamentoComponent>,
    private sugestaoService: SugestaoAgrupamentoService,
    private snackbar: SnackbarCustomService,
  ) {}

  get contratoId(): any {
    return this.data?.id
  }

  gerar() {
    this.loading = true
    this.sugestaoService.gerar(this.contratoId, this.janelaMinutos, this.modoAgrupamento).subscribe({
      next: (res: any) => {
        this.grupos = (res.data?.grupos ?? []).map((g: any) => ({
          ...g,
          passageiros: (g.passageiros ?? []).map((p: any) => ({ ...p, movingTo: null })),
          movingPassageiroId: null,
        }))
        this.semCorrespondencia = res.data?.semCorrespondencia ?? []
        this.state = 'generated'
        this.loading = false
      },
      error: () => {
        this.snackbar.error('Não foi possível gerar a sugestão.')
        this.loading = false
      },
    })
  }

  confirmar() {
    const grupos = this.grupos.map(g => ({
      itemPropostaId: g.itemPropostaId,
      passageiroIds: g.passageiros.map(p => p.id),
    }))
    this.loading = true
    this.sugestaoService.confirmar(this.contratoId, grupos).subscribe({
      next: () => {
        this.snackbar.success('Agrupamento confirmado com sucesso!')
        this.loading = false
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: () => {
        this.snackbar.error('Não foi possível confirmar o agrupamento.')
        this.loading = false
      },
    })
  }

  onRemove(grupo: GrupoUI, passageiro: PassageiroUI) {
    this.removePassengerLocal(grupo.itemPropostaId, passageiro.id)
  }

  toggleMoving(grupo: GrupoUI, passageiro: PassageiroUI) {
    const isActive = grupo.movingPassageiroId === passageiro.id
    for (const g of this.grupos) {
      g.movingPassageiroId = null
      for (const p of g.passageiros) p.movingTo = null
    }
    if (!isActive) {
      grupo.movingPassageiroId = passageiro.id
    }
  }

  confirmMove(grupo: GrupoUI, passageiro: PassageiroUI) {
    if (passageiro.movingTo == null) return
    this.movePassengerLocal(grupo.itemPropostaId, passageiro.id, passageiro.movingTo)
    grupo.movingPassageiroId = null
  }

  getOtherGroups(currentItemPropostaId: number): GrupoUI[] {
    return this.grupos.filter(g => g.itemPropostaId !== currentItemPropostaId)
  }

  private movePassengerLocal(fromId: number, passageiroId: string, toId: number) {
    const from = this.grupos.find(g => g.itemPropostaId === fromId)
    const to = this.grupos.find(g => g.itemPropostaId === toId)
    if (!from || !to) return

    const idx = from.passageiros.findIndex(p => p.id === passageiroId)
    if (idx === -1) return

    const [p] = from.passageiros.splice(idx, 1)
    p.movingTo = null
    to.passageiros.push(p)
    from.totalPassageiros = from.passageiros.length
    to.totalPassageiros = to.passageiros.length
  }

  private removePassengerLocal(fromId: number, passageiroId: string) {
    const from = this.grupos.find(g => g.itemPropostaId === fromId)
    if (!from) return

    const idx = from.passageiros.findIndex(p => p.id === passageiroId)
    if (idx === -1) return

    const [p] = from.passageiros.splice(idx, 1)
    p.movingTo = null
    this.semCorrespondencia.push({ id: p.id, nome: p.nome, hora: p.hora, motivo: 'Removido manualmente' })
    from.totalPassageiros = from.passageiros.length
  }

  close() {
    this.dialogRef.close()
  }
}
